<div class="common-text-input__container">
  <div [ngClass]="fieldTypeFormu.fieldEncodings?'common-text-input__container-box common-text-input__container-box--disabled':'common-text-input__container-box-disabled-border'"
    disabled="true">
    <div class="common-text-input__block-header">
      <div class="common-text-input__label">
        @if(fieldTypeFormu.fieldEncodings){
        <i [class]="'common-text-formu__icon-encoding' + (field.color?' common-text-formu__icon-encoding-' + (field.color | colors:'highlightListColors'):'')"
          [ngClass]="field.color?'lf-icon-step-final':'lf-icon-step-first'"></i>
        }
        <span class="common-text-input__text-label">{{fieldTypeFormu.titleField}}</span>
        <div class="common-text-input__block-buttons">
          @if(field.description) {
            <tooltip-info [description]="field.description"
            [field]="field"></tooltip-info>
          }
          @if (field.references?.length) {
            <tooltip-law [references]="field.references"
            [field]="field"></tooltip-law>
          }
          @if (field.relatedInfo?.length) {
            <button class="common-button__icon-sm-noborder"
              pTooltip="{{'common.related-info'| afTranslate}}"
              tooltipPosition="top">
              <i class="lf-icon-search-text common-icon__md"
              (click)="openModalRelatedInfo(field.relatedInfo, $event)"></i>
            </button>
          }
          @if (field.inReport !== null && field.inReport !== undefined && !isLanding){
            <tooltip-in-report [inReport]="fieldTypeFormu.inReport"></tooltip-in-report>
          }
        </div>
      </div>
    </div>
    <div class="common-text-input__block-input">
      @if (fieldTypeFormu.fieldEncodings && !fieldTypeFormu.field.showValueWithCode) {
        <span class="common-text-formu__span-text">
          {{field.evaluatedValue?.nvarcharValue}}
        </span>
      } @else {
        <p-inputNumber
          class="common-text-input__container-input"
          styleClass="common-text-input__input-number"
          mode="decimal"
          [inputId]="'field-item-formu-' + field.id"
          [maxFractionDigits]="fieldTypeFormu.decimals"
          [useGrouping]="fieldTypeFormu.separator"
          [suffix]="(fieldTypeFormu.fieldEncodings && fieldTypeFormu.field.showValueWithCode)?' - ' + field.evaluatedValue?.nvarcharValue:''"
          [disabled]="true"
          [(ngModel)]="fieldTypeFormu.fieldEvaluatedValue"></p-inputNumber>
      }
      <!-- <span class="common-text-formu__span-text">{{fieldTypeFormu.fieldEncodings?field.evaluatedValue.nvarcharValue:fieldTypeFormu.fieldEvaluatedValue}}</span> -->
    </div>
  </div>
</div>
